export default __webpack_public_path__ + "static/media/FoodItemsIcon.d07ddeac.svg";